<template>
  <div class="mx-auto mb-12 max-w-md text-center">
    <ConfirmationSvg class="w-48" />
    <p class="my-8 text-xl text-dark">Dernière étape : confirmez votre e-mail pour envoyer votre message.</p>
    <p class="mb-0 text-sm">Vous n'avez rien reçu&nbsp;?</p>
    <a v-if="!confirmationInstructionsResent" href="#" class="text-sm" @click="resendConfirmationInstructions">
      Renvoyer un e-mail de confirmation
    </a>
    <p v-else class="text-sm">
      Un e-mail a été envoyé. Si le problème persiste,
      <a href="/contact" class="whitespace-nowrap">contactez-nous</a>
      .
    </p>
  </div>
</template>

<script setup>
import ConfirmationSvg from './ConfirmationSvg.vue'
import { getCurrentInstance, ref } from 'vue'
import { useApi } from '@/apps/shared/composables'
import { useMainStore } from '../stores/main'
const store = useMainStore()

const confirmationInstructionsResent = ref(false)

const rootInstance = getCurrentInstance().root
const api = useApi()
const resendConfirmationInstructions = async event => {
  event.preventDefault()
  await api.get(
    `/users/${
      store.loggedUser?.slug ?? rootInstance.data.currentUserSlug
    }/resend_fast_contact_confirmation_instructions?conversation_id=${store.conversation.id}`
  )
  confirmationInstructionsResent.value = true
}
</script>
